import json from "./ApiIp.json";
let data = [];
data = json;
export default data;
